/* eslint-disable */
// @ts-nocheck
import React from 'react';
import { components } from 'react-select';
import { withClassName, withClassNameToInnerProps } from './withClassName';
import ClearIndicator from './ClearIndicator';
import DropdownIndicator from './DropdownIndicator';
import MultiValueRemove from './MultiValueRemove';

/**
 * This is hack to support react-select migration, so that we do not
 * break QA automation. QA automation is using class selector + html tag selector
 * to interact with elements controlled by react-select.
 *
 * Until QA automation is migrated to use react-select's new className,
 * This wrappedCompnents will be there to support it.
 */
const wrappedComponents = {
  DropdownIndicator,
  IndicatorSeparator: () => null,
  Placeholder: withClassName(components.Placeholder, 'Select-placeholder'),
  ClearIndicator: withClassName(ClearIndicator, 'Select-clear'),
  Option: withClassName(components.Option, 'Select-option'),
  Control: withClassName(components.Control, 'Select-control'),
  Input: withClassName(components.Input, 'Select-input'),

  /**
   * Some of our automated testing are looking for Select-menu-outer,
   * to located dropdown menu,
   * Until tests are mograted, following className shall be supplied.
   */
  Menu: withClassName(components.Menu, 'Select-menu-outer'),
  MenuList: withClassName(components.MenuList, 'Select-menu'),
  MultiValueLabel: withClassNameToInnerProps(components.MultiValueLabel, 'Select-value-label'),
  MultiValueRemove,

  /**
   * react-select does not wrap value into internal span element.
   * Therefore, value of single value is directly under Select-value.
   * Since our testing framework is looking for Select-value-label for text contents,
   * Select-value-label className shall be supplied until tests are migrated.
   */
  SingleValue: withClassName(components.SingleValue, 'Select-value Select-value-label'),
  ValueContainer: withClassName(
    components.ValueContainer,
    'Select-container',
    (props) => props.isMulti && 'Select-multi-value-wrapper'
  ),
  MultiValueContainer: withClassNameToInnerProps(components.MultiValueContainer, 'Select-multi-value'),
};
export default wrappedComponents;
